module.exports = __webpack_public_path__ + "img/yearning.eb6db58d.svg";